import { handleLongText, slugToTitleCase } from 'config/libraries';
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom';

export const List = ({response}) => {
    return (
        <Fragment>
            {
                response && response.map((item, index) => {
                    return (
                        <div key={index} className="box jl_grid_layout1 blog_grid_post_style post-2957 post type-post status-publish format-standard has-post-thumbnail hentry category-inspiration tag-morning">
                            <div className="jl_grid_w" style={{ marginBottom: 70 }}>
                                <div className="jl_img_box jl_radus_e" style={{ marginBottom: 0 }}>
                                    <iframe
                                        style={{ marginBottom: 0 }}
                                        width="100%"
                                        height="280"
                                        src={`https://www.youtube.com/embed/${item.url_video}`}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        title="Embedded youtube"
                                        />
                                </div>
                                <div className="text-box" style={{ marginTop: 10 }}>
                                    <h3>
                                    {handleLongText(item.judul_video, 50)}
                                    </h3>
                                    <span className="jl_post_meta">
                                        <span className="jl_author_img_w">
                                            <span className="post-date">
                                                <i className="jli-pen" />{item.created_at}
                                            </span>
                                        </span>
                                    </span>
                                    <p>{handleLongText(item.deskripsi_video, 130)}</p>
                                </div>
                            </div>
                        </div>
                    )
                    
                })
            }
        </Fragment>
    )
};